export default "__VITE_ASSET__CMgtvN_H__"